module.exports = __webpack_public_path__ + "img/ALsumLogo.264dfb08.png";